import { transformValueToFullPercentage } from '@features/campaigns/performance/shared/utils/transformValueToFullPercentage.ts';
import { createNumberFormat } from '@shared/utils/numberFormat.ts';

const maximumPercentageFractionDigits = 3;

const percentageNumberFormat = createNumberFormat({ maximumFractionDigits: maximumPercentageFractionDigits });
const percentageNumberFormatWithTwoDigits = createNumberFormat({
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatPercentage(value: number): string {
  return `${percentageNumberFormat.format(value)}%`;
}

export function formatFullPercentage(value: number): string {
  return formatPercentage(transformValueToFullPercentage(value));
}

export function formatFullPercentageWithTwoDigits(value: number): string {
  const transformedValue = transformValueToFullPercentage(value);
  const isZeroOrInteger = transformedValue === 0 || Number.isInteger(transformedValue);
  const formattedValue = isZeroOrInteger
    ? percentageNumberFormat.format(transformedValue)
    : percentageNumberFormatWithTwoDigits.format(transformedValue);

  return `${formattedValue}%`;
}
